import { render, staticRenderFns } from "./Videolink.vue?vue&type=template&id=b3bd8692&scoped=true&"
import script from "./Videolink.vue?vue&type=script&lang=js&"
export * from "./Videolink.vue?vue&type=script&lang=js&"
import style0 from "./Videolink.vue?vue&type=style&index=0&id=b3bd8692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd8692",
  null
  
)

export default component.exports